// Loader for blog posts. Drop files into ./content as default exports and they'll be picked up.
type ImageContent = {
  type: 'image';
  src: string;
  alt: string;
  /** Pixel size of the file, for the <img> width/height attributes (no layout shift). */
  width?: number;
  height?: number;
  caption?: string;
  position?: 'left' | 'right' | 'center';
};

type ContentItem = string | ImageContent;

type Post = {
  slug: string;
  title: string;
  category: string;
  date: string;
  readTime: string;
  excerpt: string;
  content: ContentItem[];
};

// Use webpack require.context to dynamically discover posts at build time
const req = (require as any).context("./content", false, /\.ts$/);

const posts: Post[] = req
  .keys()
  .map((key: string) => {
    const mod = req(key);
    return mod && mod.default ? mod.default : null;
  })
  .filter(Boolean)
  // sort by date descending (assumes date strings parseable by Date)
  .sort((a: Post, b: Post) => new Date(b.date).getTime() - new Date(a.date).getTime());

const getPost = (slug: string) => posts.find((p) => p.slug === slug) || null;

export { posts, getPost };
export type { Post, ContentItem, ImageContent };
